import { UserCircleIcon } from '@heroicons/react/solid'
import { Navigate } from 'react-router-dom'
import { Form, Paragraph, StickyFooter, Title } from 'src/components'
import { savedTokens, useAuth } from 'src/auth'
import EmailHelpBox from 'src/components/Layout/EmailHelpBox'
import { savedOrganization } from './storage'
import CustomButton from 'src/components/Shared/UIComponents/Button'

export default function Login() {
  const { login, isLoading } = useAuth()
  const [tokens] = savedTokens.useState(null)
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  const [organization, setOrganization] = savedOrganization.useState('')

  if (tokens) {
    return <Navigate to="../success" />
  }

  return (
    <Form
      onSubmit={(e) => {
        e.preventDefault()
        login()
      }}
    >
      <Title label="Login" className="col-span-full" />
      <Paragraph className="col-span-full">
        We have created your organisation and an admin user for you. You should
        have received an email with the necessary login credentials. If you did
        not receive an email, please check your spam folder.
      </Paragraph>

      <Paragraph className="col-span-full">
        Please login with these user credentials by clicking the <b>login</b>{' '}
        button below. You'll be asked to change your password after the first
        login.
      </Paragraph>

      <CustomButton
        type="submit"
        label="login"
        icon={<UserCircleIcon />}
        iconSize={5}
        iconColor="text-white"
        iconPosition="left"
        isLoading={isLoading}
        className="mb-6 text-lg text-white bg-accent-foreground hover:text-white hover:shadow-lg focus:shadow-lg"
        size="lg"
      />

      <div className="col-span-full text-secondary">
        <Paragraph>
          Alternatively, you can also find your login credentials below:
        </Paragraph>

        <ul className="list-none">
          <li>
            username:{' '}
            {organization ? (
              <b>{organization}</b>
            ) : (
              <i>the organization you chose in the previous step</i>
            )}
          </li>
          <li>
            password: <b>MobileConnect1234!</b>
          </li>
        </ul>
      </div>

      <StickyFooter>
        <EmailHelpBox className="flex-1" />
      </StickyFooter>
    </Form>
  )
}
